import React, { FC, useEffect, useMemo, useState, useRef } from "react";
import MovieDescription from "../../../../../components/TicketBooking/MovieDescription";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import {
  IFormatedTicketType,
  ITicketVoucher,
  MODAL_TYPE,
  MovieInfo,
  TICKET_FLOW_TYPES,
} from "../../../../../models/tickets";
import {
  calculateServiceCharge,
  checkPremiumMovie,
  generateUsersessionId,
  getRndInteger,
  ticketPriceCalculation,
} from "../../../../../utils/tickets";
import {
  BRANDS,
  COUNTRY,
  EXCLUDE_BOOKING_FEE_SESSION,
  PREMIUM_SERCHRG_ATTR,
} from "../../../../../constants/app";
import { API_REQUEST_TYPE, COUNTRY_IMAGE_CONFIG, IMAGE_URL_CONFIG, URLS } from "../../../../../constants/url";
import "./noOfSeats.scss";
import {
  addTicketApi,
  getVoucherTicketsApi,
} from "../../../../../services/films";
import {
  addTicketSuccess,
  setModal,
  setTicketVoucher,
} from "../../../../../store/ticketBooking/action";
import { TICKET_FLOW } from "../../../../../constants/ticket";
import { formatUserDetails } from "../../../../../utils/formatter";
import { toast } from "react-toastify";
import SwapFilter from "../../../../../components/UI/Filters/SwapFilter";
import { useLocation, useNavigate } from "react-router";
import { setPopupInfo } from "../../../../../store/application/action";
import { setMembershipModal, showLogin } from "../../../../../store/auth/action";
import { ROUTES } from "../../../../../constants/path";
import moment from "moment";
import Button from "../../../../../components/UI/Button";
import { Tooltip } from "react-tooltip";
import { MOVIE_EXPERIENCE_CONTENT, MOVIE_EXPERIENCE_CONTENT_NEW, NEW_PREMIUM_DATE } from "../../../../../constants/experience";
interface INoOfSeatsProps {
  onCancel: (error?: string) => void;
}

const NoOfSeats: FC<INoOfSeatsProps> = ({ onCancel }) => {
  const {
    brandId,
    settings,
    films,
    ticketType,
    hasGL,
    countryId,
    ticketVoucher,
    currentCinema,
    userDetails,
    isLoggedIn,
    modalType,
    nextModal,
    inProgress,
    sharedUserSession,
    seatSwapDetails,
    ticketDetails,
    infoPopup,
    memberDetail,
    serviceChargeConfig
  } = useSelector((state: RootState) => ({
    countryId: state.applicationReducer.countryId,
    brandId: state.applicationReducer.brandId as BRANDS,
    currentCinema: state.applicationReducer.currentCinema,
    settings: state.applicationReducer.settings,
    modalType: state.ticketBookingReducer.modal.type,
    nextModal: state.ticketBookingReducer.modal.nextModal,
    films: state.ticketBookingReducer.films,
    ticketType: state.ticketBookingReducer.ticketType,
    hasGL: state.ticketBookingReducer.hasGL,
    ticketVoucher: state.ticketBookingReducer.ticketVoucher,
    userDetails: state.authReducer.userDetails,
    isLoggedIn: state.authReducer.isLoggedIn,
    inProgress: state.ticketBookingReducer.inProgress,
    sharedUserSession: state.ticketBookingReducer.sharedUserSession,
    seatSwapDetails: state.ticketBookingReducer.seatSwapDetails,
    ticketDetails: state.ticketBookingReducer.ticketDetails,
    infoPopup: state.applicationReducer.infoPopup,
    memberDetail: state.authReducer.memberDetail,
    serviceChargeConfig: state.ticketBookingReducer.serviceChargeConfig
  }));

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const voucherInputRef: React.RefObject<HTMLInputElement> = useRef(null);
  const [tickets, setTickets] = useState<IFormatedTicketType[]>([]);
  const [voucherErrors, setVoucherErrors] = useState<string>("");
  const [errors, setError] = useState<string>("");

  useEffect(() => {
    if (ticketType && ticketType.length > 0) {
      if(ticketDetails && ticketDetails.ticketTypes && Array.isArray(ticketDetails.ticketTypes) && ticketDetails.ticketTypes.length > 0){
        setTickets(
          ticketType.map((v: any) => {
            const ticketTypes = [...ticketDetails.ticketTypes];
            const tkt = ticketTypes.find((t:IFormatedTicketType)=>t.ticketTypeCode === v.TicketTypeCode);
            return tkt?{...tkt}:{
              areaCategoryCode: v.AreaCategoryCode,
              qty: 0,
              bookingFees: 0,
              description: v.Description,
              price: +v.Price,
              ticketTypeCode: v.TicketTypeCode,
              total: 0,
              OptionalBarcode: "",
              IsAvailableForLoyaltyMembersOnly: v.IsAvailableForLoyaltyMembersOnly,
              IsShowToNonLoyaltyMembers: v.IsShowToNonLoyaltyMembers,
              loyaltyRecognitionId: v.LoyaltyRecognitionId
                ? v.LoyaltyRecognitionId
                : undefined,
              isPackageTicket: v.IsPackageTicket,
              isPackageContent: v.PackageContent,
              Info: v?.Info
            };
          })
        );
      }else{
        setTickets(
          ticketType.map((v: any) => {
            return {
              areaCategoryCode: v.AreaCategoryCode,
              qty: 0,
              bookingFees: 0,
              description: v.Description,
              price: +v.Price,
              ticketTypeCode: v.TicketTypeCode,
              total: 0,
              OptionalBarcode: "",
              IsAvailableForLoyaltyMembersOnly: v.IsAvailableForLoyaltyMembersOnly,
              IsShowToNonLoyaltyMembers: v.IsShowToNonLoyaltyMembers,
              loyaltyRecognitionId: v.LoyaltyRecognitionId
                ? v.LoyaltyRecognitionId
                : undefined,
              isPackageTicket: v.IsPackageTicket,
              isPackageContent: v.PackageContent,
              Info: v?.Info    
            };
          })
        );
      }
    } else {
      if (
        (!Array.isArray(ticketType) &&
          ticketType.hasOwnProperty("ResponseCode") &&
          ticketType.ResponseCode != 0) ||
        (Array.isArray(ticketType) && ticketType.length == 0)
      ) {
        onCancel("Tickets not available for this session");
      }
    }
  }, [ticketType]);

  const { price, bookingFees, total } = useMemo(() => {
    setError("");
    return ticketPriceCalculation(tickets);
  }, [tickets]);

  const onClickMinus = (index: number) => {
    const ticketArray = [...tickets];
    const totalTicketCount = tickets.reduce(
      (acc: number, v: any) => (acc = acc + v.qty),
      0
    );
    const currentTicket: any = ticketArray[index];

    if (totalTicketCount <= 0 || currentTicket.qty <= 0) {
      return;
    }

    const serviceFee = calculateServiceCharge({
      hasGL,
      brandId,
      films,
      serviceCharge: serviceChargeConfig,
      isMember
    }) 
    currentTicket.qty = currentTicket.qty - 1;
    currentTicket.bookingFees =
      currentTicket.bookingFees - (currentTicket.isPackageTicket ? (serviceFee*currentTicket.isPackageContent?.Quantity) : serviceFee);
    currentTicket.total = currentTicket.qty * currentTicket.price;
    ticketArray[index] = currentTicket;
    setTickets(ticketArray);
  };

  const onClickPlus = (index: number, barcode?: string) => {
    const ticketArray = [...tickets];
    const totalTicketCount = tickets.reduce(
      (acc: number, v) => (acc = acc + v.qty),
      0
    );
    const currentTicket = ticketArray[index];
    const serviceFee = calculateServiceCharge({
      hasGL,
      brandId,
      films,
      serviceCharge: serviceChargeConfig,
      isMember
    })
    if (totalTicketCount >= 10) {
      setError("A maximum of 10 tickets can be purchased per transaction.");
      return;
    }

    if (settings && settings.memberFreeTkt && settings.memberFreeTkt.ticketTypeCode && settings.memberFreeTkt.movies && settings.memberFreeTkt.ticketTypeCode.includes(currentTicket.ticketTypeCode) && settings.memberFreeTkt.movies.includes(currentTicket.description)) {
      if (currentTicket.qty >= settings.memberFreeTkt.qtyLimit) {
        setError(`A maximum of ${settings.memberFreeTkt.qtyLimit} Member Free ticket${settings.memberFreeTkt.qtyLimit > 1?'s':''} can be purchased.`);
        return;
      }
    }

    currentTicket.qty = currentTicket.qty + 1;
    currentTicket.bookingFees =
      currentTicket.bookingFees + (currentTicket.isPackageTicket ? (serviceFee*currentTicket.isPackageContent?.Quantity) : serviceFee);      
    currentTicket.total = currentTicket.qty * currentTicket.price;
    if (barcode) {
      currentTicket.OptionalBarcode = barcode;
    }
    ticketArray[index] = currentTicket;
    setTickets(ticketArray);
  };

  const clearVoucherDetails = (type: string, index: number) => {
    const tempVouchers = ticketVoucher;
    dispatch(setTicketVoucher(tempVouchers));
    tempVouchers.splice(index, 1);
    const typeIndex = tickets.findIndex((object) => {
      return object.ticketTypeCode == type;
    });
    onClickMinus(typeIndex);
  };

  const getVoucherDetails = async () => {
    const barcode = voucherInputRef?.current?.value;
    setVoucherErrors("");
    if (!barcode) {
      setVoucherErrors("Voucher code is required");
      return;
    }
    const d = new Date(); // for now
    const currentTime =
      d.getDate() +
      "" +
      d.getHours() +
      "" +
      d.getMinutes() +
      "" +
      d.getMilliseconds();
    let theatreId = currentCinema.cinemaId;
    theatreId = theatreId.substr(0, 3);
    let rand = getRndInteger(1000000000, 9999999999);
    const userSessionID = `${films.sessionId}${theatreId}${currentTime}${rand}`;
    let checkCode = ticketVoucher.some(
      (el: ITicketVoucher) => el.cardNumber === barcode
    );
    if (checkCode) {
      setVoucherErrors("Voucher already added");
      return false;
    }
    const params = {
      cardNumber: barcode,
      cinemaId: currentCinema.cinemaId,
      sessionId: films.sessionId,
      requestType: "getVoucherTickets",
      countryId: countryId,
      userSessionId: userSessionID,
    };
    const {
      data: { data },
    } = await getVoucherTicketsApi(params);

    let res = JSON.parse(data);

    if (res.ErrorDescription != null) {
      setVoucherErrors(res.ErrorDescription);
      return;
    }
    const index = tickets.findIndex((object) => {
      return object.ticketTypeCode == res.Tickets[0].TicketTypeCode;
    });
    const tempVouchers = ticketVoucher;
    tempVouchers.push({
      description: res.Tickets[0].Description,
      cardNumber: barcode,
      type: res.Tickets[0].TicketTypeCode,
    });
    dispatch(setTicketVoucher(tempVouchers));
    onClickPlus(index, barcode);
  };

  const Voucher = () => {
    return countryId === COUNTRY.STA ? (
      <div className="voucher_box">
        <label className="seat-label">Have a voucher?</label>
        {ticketVoucher.map((voucher: ITicketVoucher, index: number) => (
          <div className="search_common_disabled">
            <label>{voucher.description}</label>
            <div>
              <input
                type="text"
                className="form-control"
                value={voucher.cardNumber}
                disabled
              />
              <button
                type="button"
                onClick={() => clearVoucherDetails(voucher.type, index)}
              >
                <img src={URLS.CLOSE_ICON} alt="" />
              </button>
            </div>
          </div>
        ))}
        <div className="search_common">
          {ticketVoucher.length > 0 ? <label>Add Another</label> : null}
          <div>
            <input
              type="text"
              className="form-control"
              placeholder="Enter card number"
              ref={voucherInputRef}
            />
            <button type="button" onClick={() => getVoucherDetails()}>
              <img src={URLS.RIGHT_ARROW} alt="" />
            </button>
          </div>
        </div>
        {voucherErrors ? (
          <div className="error_message">{voucherErrors}</div>
        ) : null}
      </div>
    ) : null;
  };

  const onCancelTicket = () => {
    onCancel();
  };

  const isMember = useMemo(()=>{
    return memberDetail && memberDetail.LoyaltySessionToken?true: false;
  },[memberDetail]);
  

  const onNext = async () => {
    const qty = tickets.reduce((qty: number, num: IFormatedTicketType) => {
      return qty + num.qty;
    }, 0);
    if (qty === 0) {
      setError("Select at least one ticket type");
      return;
    }

    if (films?.ratingDescription === 'R' && !infoPopup?.data?.rRatedStatus) {
      dispatch(setPopupInfo({ open: true, type: "R_rated" }));
      return;
    }

    const bookedTickets = tickets.filter((v) => v.qty > 0);
    const payload = {
      cinemaId: films?.cinemaId,
      countryId: films?.countryId,
      hasGL: hasGL,
      hasSoho: films.sessionAttributes === "Soho" ? 1 : 0,
      movieId: films?.movieId,
      isPremium: PREMIUM_SERCHRG_ATTR[brandId].includes(films.sessionAttributes)?1:0,
      isMember: isMember,
      excludeBookingFee: EXCLUDE_BOOKING_FEE_SESSION.includes(films?.sessionAttributes?.toLowerCase())?1:0,
      day: moment.parseZone(films?.showDateTime).format("dddd"),
      requestType: API_REQUEST_TYPE.ADD_TICKET,
      reservedSeating: 0,
      sessionId: films?.sessionId,
      ticketTypes: bookedTickets,
      userDetials:
        userDetails && userDetails?.result?.memberRefId!
          ? formatUserDetails(userDetails, countryId, films?.cinemaId!)
          : {},
      userSessionId: ticketDetails?.userSessionId,
      isMobile: 0,
      userAgent: navigator.userAgent,
    };
    const ticketResponse = await addTicketApi(payload);
    const {
      data: {
        data: { error, saleId },
      },
    } = ticketResponse;
    if (error) {
      toast.error(error && error === 'SeatsUnavailable'?'Seats Unavailable':error)
      return;
    }

    const ticketType: TICKET_FLOW_TYPES = modalType;
    const next: MODAL_TYPE = nextModal;
    const modal = TICKET_FLOW[ticketType][next];

    dispatch(
      addTicketSuccess({
        total,
        bookingFees,
        price,
        reservedSeating: payload.reservedSeating,
        selectedSeats: [],
        ticketTypes: payload.ticketTypes ? payload.ticketTypes : [],
        userSessionId: saleId,
      })
    );
    dispatch(setModal({ ...modal, type: modalType }));
  };

  useEffect(() => {
    if (infoPopup?.type && infoPopup?.data?.rRatedStatus && infoPopup?.type === "R_rated" && infoPopup.data.rRatedStatus) {
      onNext();
    }
  }, [infoPopup])
  
  const isSeatSwap = useMemo(() => {
    return pathname.includes("/seat-swap/") && seatSwapDetails ? true : false;
  }, [pathname, seatSwapDetails]);

  const ticketBookingFee = useMemo(()=>{
    return calculateServiceCharge({
      hasGL,
      brandId,
      films,
      serviceCharge: serviceChargeConfig,
      isMember
    })
  },[hasGL,films, serviceChargeConfig,isMember])


  const joinMembership = ()=>{
    if(isLoggedIn){
      dispatch(setMembershipModal(true))
    }else{
      dispatch(showLogin(true));
    }

    onCancel();
    navigate(
      `/${currentCinema?.alias}/${ROUTES.NOW_PLAYING}`
    );
  }

  const showLink = useMemo(()=>{
    return tickets.filter((ticketType: IFormatedTicketType, index: number) => {
      return ticketType.IsShowToNonLoyaltyMembers === true && ticketType.IsAvailableForLoyaltyMembersOnly === true && !isMember?true:false
    }).length > 0 && countryId === COUNTRY.AFC?true:false
  },[tickets,isMember])

  const totalTicketQty = useMemo(() => {
    return tickets.reduce((acc: number, v: IFormatedTicketType) => {
      acc = acc + (v.isPackageTicket?v.qty*v.isPackageContent.Quantity:v.qty)
      return acc;
    }, 0)
  }, [tickets])

  const isPremiumMovie = useMemo(() => {
    if (countryId && films && films.movieId) {
      return checkPremiumMovie({ movieId: films.movieId, countryId, cinemaId: films?.cinemaId } as MovieInfo);
    } else {
      return false
    }
  }, [countryId, films])

  const PremiumExperience = ({ ticketType }: any) => {
    const type = ticketType?.description?.toLowerCase()?.includes("premium") ? 'premium' : ticketType?.description?.toLowerCase()?.includes("standard") ? 'standard' : '';
    const experience = type ? type.toUpperCase() : '';
    const showDateTime = moment(films?.showDateTime).utcOffset(currentCinema?.timeZone).format('YYYY-MM-DD');
    const newPremiumDateTime = moment(NEW_PREMIUM_DATE);   
    const isNew = moment(showDateTime).isSameOrAfter(newPremiumDateTime); 
    const content: any = isNew ? MOVIE_EXPERIENCE_CONTENT_NEW :MOVIE_EXPERIENCE_CONTENT;
    return type ? <div className={type + '-card'}>
      <div className={type + "-header"}>
        <img
          alt="Premium Icon" className={type + "-icon"}
          src={COUNTRY_IMAGE_CONFIG[countryId] + content[experience]?.img1}
        />
      </div>
      <ul className={type + "-list"}>
        <h3 className={type + "-title"}>{content[experience]?.title}</h3>
        {content[experience]?.description?.map((d: string) => <li>{d}</li>)}
      </ul>
    </div> : null
  }

  return (
    <div className={`app-no-of-seats row ${countryId === COUNTRY.CON?'consolidated':countryId === COUNTRY.AFC?'angelika-film-center':''} `}>
      <MovieDescription />
      {settings.enableTicketBooking == 0 ? (
        <div className="col-md-8 bookingnotallowed">
          Online ticket booking not available
        </div>
      ) : (
        <div className="col-md-8 p-l-10">
          {modalType !== TICKET_FLOW_TYPES.MULTI_TICKETING &&
          modalType !== TICKET_FLOW_TYPES.MULTI_TICKETING_FB &&
          sharedUserSession &&
          sharedUserSession.length > 0 ? (
            <div className="col-12 socialSharing">
              <span>{sharedUserSession[0].userName}</span> is sharing their
              seats with you!
            </div>
          ) : null}
          {isSeatSwap ? <SwapFilter /> : null}
          <div className="no-seats form_page">
          {showLink?<div className="join-membership-banner"><span className="join-membership-link">Become an Angelika Member - Sign Up for FREE NOW!</span><button className="btn black_btn" onClick={joinMembership}>JOIN NOW</button></div>:null}
            <div className="seat_type">
              {countryId === COUNTRY.AFC?<div className="online-fee">
                <img
                  src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + "notification-icon-black.svg"}
                  alt="Notification Icon"
                  className="premium-icon"
                />
                <span className="online-fee-text">
                  An online booking fee of $ {ticketBookingFee} per ticket will be added to your total order.
                </span>
              </div>:null}
                {tickets.map((ticketType: IFormatedTicketType, index: number) => {
                  const disableTicket = ticketType.IsShowToNonLoyaltyMembers === true && ticketType.IsAvailableForLoyaltyMembersOnly === true && !isMember?true:false
                 return <>
                  {isPremiumMovie?<PremiumExperience ticketType={ticketType}/>:null}
                  <div className={`single_row ${disableTicket?'op-3':''}`}>
                    {ticketType.price !== 0 ||
                      (isLoggedIn && ticketType.price === 0) ? (
                      <>
                        <div className="person_type">
                          <label className={isPremiumMovie && ticketType?.description?.toLowerCase()?.includes("premium") ? "seat-label premium" : "seat-label"}>
                            {ticketType.description}
                          </label>
                          {
                            ticketType?.Info ? 
                            <>
                            <span
                              className="ticket-type-info"
                              data-tooltip-id={`info-${index}`}
                              data-tooltip-html={`<div style="text-align: center;">${ticketType?.Info.replace(/\n+/g, '\n').replace(/\n/g, "<br>")}</div>`}
                            >
                            <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + "notification-icon-black.svg"}  alt=""/>
                            </span>
                            <Tooltip id={`info-${index}`} className="ticket-type-info-data" place="top" />
                            </>
                            : null

                          }
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span
                                className="btn_minus"
                                onClick={() => !disableTicket && onClickMinus(index)}
                              >
                                &nbsp;
                              </span>
                            </div>
                            <input
                              type="number"
                              className="form-control"
                              aria-label="Seat"
                              value={ticketType.qty}
                              disabled
                            />
                            <div className="input-group-append">
                              <span
                                className="btn_plus"
                                onClick={() => !disableTicket && onClickPlus(index)}
                              >
                                &nbsp;
                              </span>
                            </div>
                          </div>
                        </div>
                        {tickets.length > 0 ? (
                          <div className={`price_wrap ${ticketType.isPackageTicket?'mt-3':''}`}>
                             <div className="price">
                               <label className={`seat-label ${index >0 && !isPremiumMovie?'invisible':'visible'}`}>Price</label>
                               <p className="seat-label m-0">
                                 ${(ticketType.price + (ticketType.isPackageTicket?(ticketBookingFee*ticketType.isPackageContent.Quantity):ticketBookingFee)).toFixed(2)}
                               </p>
                               <div>
                                 <p className="desc-label">Admission: ${ticketType.price.toFixed(2)}</p>
                                 <p className="desc-label">Booking Fee{ticketType.isPackageTicket?' x '+ticketType.isPackageContent.Quantity:''}: ${(ticketType.isPackageTicket?(ticketBookingFee*ticketType.isPackageContent.Quantity).toFixed(2):ticketBookingFee.toFixed(2))}
                                 </p>
                               </div>
                             </div>
                            <div className="total">
                              <label className={`seat-label ${index >0 && !isPremiumMovie?'invisible':'visible'}`}>Total</label>
                              <p className="seat-label m-0">
                                ${((ticketType.total) + (ticketBookingFee * (ticketType.isPackageTicket?ticketType.qty*ticketType.isPackageContent.Quantity:ticketType.qty))).toFixed(2)}
                              </p>
                              {ticketType.qty > 0?<div>
                                 <p className="desc-label">{ticketType.description.replace(/\n/i,'').replace(/^.*BOGO:.*$/i,'BOGO')} Admission x {ticketType.qty}: ${ticketType.total.toFixed(2)}</p>
                                 <p className="desc-label">Booking Fee x {(ticketType.isPackageTicket?ticketType.qty*ticketType.isPackageContent.Quantity:ticketType.qty)}: ${(ticketBookingFee * (ticketType.isPackageTicket?ticketType.qty*ticketType.isPackageContent.Quantity:ticketType.qty)).toFixed(2)}
                                 </p>
                               </div>:null}
                            </div>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                  </div>
                  </>
                })}
              <Voucher />
            </div>
            {errors ? (
              <div className="error_message mx-0 my-3">
                <span>{errors}</span>
              </div>
            ) : null}
            {/* <div *ngIf="errorEmpty" className="error_message">
        <span> No of Seat is required</span>
      </div>
      <div *ngIf="errorMessage != '' " className="error_message">
        <span>{{errorMessage}}</span>
      </div>
      <div *ngIf="seatError">
        <h2 className="text-left seats_not_available">
          Seats are currently not available
        </h2>
      </div> */}
          </div>

          <div className="user-pay-details">
            {/* <div class="row" style="margin-top: 30px;" *ngIf="showVoucherInfo">
    <div class="col-12"><p><span style="color: red">Please note - </span> NSW Parents vouchers may only redeemed for ticket purchases. If you’d like to add any Food and Beverage items to your transaction, you will be able to pay the difference during check out.</p></div>
  </div> */}
            <div className="row form_page">
              <div className="col-12 col-md-12 user_coloum">
                <div className="">
                  {isLoggedIn && brandId ===BRANDS.AU? (
                    <>
                      <div className="welcome">Welcome back</div>
                      <div className="my-account text-capti font-size-16">
                        {userDetails?.firstName}
                      </div>
                    </>
                  ) : null}
                  {isSeatSwap ? (
                    <div className="user-details">
                      <div className="row">
                        <div className="col-12 col-md-12">
                          <div className="total">REFUND TOTAL</div>
                          <div className="total-amount">
                            ${(seatSwapDetails.totalAmount / 100).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="user-details">
                    <div className="row">
                      <div className="col-12 col-md-12">
                        <div className="total">
                          {isSeatSwap ? "NEW TOTAL" : "TOTAL ORDER"}
                        </div>
                        <div className="total-amount">${total.toFixed(2)}</div>
                        {tickets.map((v: IFormatedTicketType) =>
                          v.qty > 0 ? (
                            <div>
                              <div className="total-det">
                                {v.qty} x {v.description.replace(/\n/i,'').replace(/^.*BOGO.*$/i,'BOGO Admissions')} SEATS: $
                                {(v.qty * v.price).toFixed(2)}
                              </div>
                            </div>
                          ) : null
                        )}
                        {totalTicketQty > 0?<div className="total-det">
                          <span>{totalTicketQty} x BOOKING FEE : ${bookingFees.toFixed(2)}</span>
                        </div>: null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="movie_button_wrap text-end">
                  <Button classNames="m-r-10" onClick={onCancelTicket} text="Cancel" type="outline" />
                  <Button iconWidth={10} iconHeight={20} onClick={onNext} text= "Next" type="fill" iconPosition = "post" icon={`${IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH}arrow_right_white.svg`} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NoOfSeats;
